'use client';
import SellingProductCard from '@c/becomeASeller/SellingProduct';
import { ProductDocument } from 'models/product';
import Link from 'next/link';
import React from 'react';

const RecentlySoldSection = ({
  recentlySold,
}: {
  recentlySold: ProductDocument[];
}) => {
  if (!recentlySold || recentlySold.length === 0) return null;
  return (
    <div className="mx-auto flex max-w-[120rem] flex-col items-center gap-[6rem] px-[1rem] py-[6rem] sm:px-0 md:py-[10rem]">
      <div className="flex max-w-[80rem] flex-col">
        <div className="text-center text-[3.2rem] font-semibold">
          See what&apos;s selling
        </div>
      </div>
      <div className="mt-[5rem] flex w-full flex-col justify-stretch gap-[2.4rem] md:flex-row">
        <div className="no-scrollbar flex gap-[0.7rem] overflow-x-auto">
          {recentlySold.map((product, i) => (
            <SellingProductCard product={product} key={product.sku + '-' + i} />
          ))}
          <div className="flex h-[18rem] min-w-[19.4rem] items-center justify-center rounded-brand bg-brand-black text-[1.8rem] text-brand-white">
            See all
          </div>
        </div>
      </div>
      <div className="text-[1.6rem] font-semibold">
        Have a similar item?{' '}
        <Link href="/create-listing" className="text-brand-secondary">
          Sell yours
        </Link>
        .
      </div>
    </div>
  );
};

export default RecentlySoldSection;
